import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Link, Typography } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';

interface Props {
  children?: React.ReactElement<unknown>;
  /** Serviceコンテンツ */
  service: Service
}

export default function ServiceCard(props: Props) {
  return (
    <Card>
      <Link
        href={props.service.url}
        sx={{ textDecoration: 'none' }}
      >
        <CardActionArea
          sx={(theme) => ({
            '.card-media': {
              height: 0,
              [theme.breakpoints.up('md')]: {
                height: 250,
              },
              objectFit: 'contain',
              overflow: 'hidden',
              transition: '0.3s',
              backgroundSize: '100% auto',
              backgroundColor: theme.palette.grey[900],
            },
            '&:hover .card-media': {
              backgroundSize: '125% auto',
            },
            '.card-title': {
              position: 'relative',
              fontWeight: 'bold',
              width: 'fit-content',
              marginBottom: '1rem',
              color: theme.palette.grey[900],
              '&.active': {
                '&::after': {
                  transform: 'scale(1, 1)'
                }
              },
              '&:after': {
                position: 'absolute',
                left: 0,
                content: `''`,
                width: '100%',
                height: 4,
                background: theme.palette.grey[900],
                bottom: -1,
                transform: 'scale(0, 1)',
                transformOrigin: 'left top',
                transition: 'transform 0.3s'
              }
            },
            '&:hover .card-title': {
              '&::after': {
                transform: 'scale(1, 1)'
              }
            }
          })}>
          <CardMedia
            className="card-media"
            image={props.service.image}
          />
          <CardContent
            sx={{ minHeight: 150 }}>
            <Typography
              className='card-title'
              variant="h5"
              component="div"
            >
              {props.service.title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                minHeight: '6em',
              }}
              fontSize={'1.25rem'}>
              {props.service.summary}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Link>
    </Card>
  )
}